import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel", "form"];

  connect() {
    // Define active/inactive CSS classes
    this.activeTabClasses = (this.data.get("activeTab") || "active").split(" ");
    this.inactiveTabClasses = (this.data.get("inactiveTab") || "inactive").split(" ");

    // Use server-rendered active tab if present
    const serverActiveIndex = this.tabTargets.findIndex(
      (tab) => tab.dataset.state === "active"
    );

    if (serverActiveIndex >= 0) {
      this.index = serverActiveIndex;
      return;
    }

    // If there's a hash in the URL, select that tab
    if (this.anchor) {
      const idx = this.tabTargets.findIndex((tab) => tab.id === this.anchor);
      if (idx >= 0) this.index = idx;
    } else {
      this.showTab();
    }
  }

  // Triggered when a tab is clicked
  change(event) {
    const el = event.currentTarget;

    // Find target tab index
    if (el.dataset.index) {
      this.index = parseInt(el.dataset.index);
    } else if (el.dataset.id) {
      this.index = this.tabTargets.findIndex((t) => t.id === el.dataset.id);
    } else {
      this.index = this.tabTargets.indexOf(el);
    }

    // Fire an optional event (used by code previews, etc.)
    window.dispatchEvent(new CustomEvent("ui:tab-change", { detail: { index: this.index } }));
  }

  // Update visible tab and panel
  showTab() {
    this.tabTargets.forEach((tab, i) => {
      const panel = this.panelTargets[i];
      const active = i === this.index;

      panel.classList.toggle("hidden", !active);
      tab.dataset.state = active ? "active" : "inactive";
      panel.dataset.state = active ? "active" : "inactive";
    });

    if (this.hasFormTarget) {
      this.formTargets.forEach((form, i) => {
        const active = i === this.index;
        form.classList.toggle("tw-hidden", !active);

        form.querySelectorAll("input, select, textarea, button").forEach((el) => {
          el.disabled = !active;
        });
      });
    }
  }

  switchFormsByTabIndex() {
    const forms = document.querySelectorAll(".tabs-form")

    if (forms.length === 0) return;

    forms.forEach((form, idx) => {
      const active = idx === this.index;

      form.classList.toggle("tw-hidden", !active);

      form
        .querySelectorAll("input, select, textarea, button")
        .forEach((el) => {
          el.disabled = !active;
        });
    });
  }

  // --- Getters / Setters ---

  get index() {
    return parseInt(this.data.get("index") || 0);
  }

  set index(value) {
    this.data.set("index", Math.max(0, value));
    this.showTab();
  }

  get anchor() {
    const parts = document.URL.split("#");
    return parts.length > 1 ? parts[1] : null;
  }
}
